<template>
  <div class="burger" :class="burgerClass" @click="toggleSidebar">
    <div class="burger__inner"></div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  const mainStore = useMainStore();
  const sidebarState = computed(() => mainStore.sidebarState);
  const burgerClass = ref('');

  function toggleSidebar() {
    if (sidebarState.value > 0) {
      mainStore.setSidebarState(0);
    } else {
      mainStore.setSidebarState(1);
    }
  }

  watch(sidebarState, (val) => {
    burgerClass.value = val > 0 ? 'burger_active' : '';
  });
</script>
